module.exports = __webpack_public_path__ + "assets/img/line4.7d89ce5e.png";